import React from "react";

// Official iClean transparent logo (whitespace trimmed).
const Logo = ({ className = "h-9" }) => {
  return <img src="/iclean-logo.png?v=2" alt="iClean" className={`${className} w-auto object-contain select-none`} />;
};

export default Logo;
